module.exports = __webpack_public_path__ + "static/media/mulher-triste.3f0e634b.png";